import { render, staticRenderFns } from "./ListBenefits.vue?vue&type=template&id=5fb8a6a8&"
import script from "./ListBenefits.vue?vue&type=script&lang=js&"
export * from "./ListBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports